import React from 'react';
import { FiUserPlus, FiArrowLeft } from 'react-icons/fi';
import StudentEditorModal from './StudentEditorModal.jsx';

export function StudentFormPage({ toast, onSaved, onCancel, onPayStudent }) {
  return (
    <div className="student-form-page">
      <header className="dash-header student-form-page-header" style={{ marginBottom: '10px' }}>
        <div className="dash-header-bar student-form-page-header-bar" style={{ marginBottom: '0', padding: '8px 0' }}>
          <div className="students-header-left">
            <div className="students-header-icon">
              <FiUserPlus aria-hidden="true" />
            </div>
            <div className="dash-header-info student-form-page-info" style={{ flex: '0 1 auto', gap: 2 }}>
              <div className="student-form-heading-copy">
                <h1 className="dash-header-title">Student Form</h1>
                <p className="dash-header-subtitle">Create a new student, assign a seat, and set up their subscription in one place.</p>
              </div>
              <div className="dash-header-actions student-form-page-actions">
                <button type="button" className="dash-action-btn student-form-back" onClick={onCancel}>
                  <FiArrowLeft aria-hidden="true" />
                  <span>Back to students</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>
      <StudentEditorModal inline toast={toast} onClose={onCancel} onSaved={onSaved} onPayStudent={onPayStudent} />
    </div>
  );
}

export default StudentFormPage;
